module.exports = __webpack_public_path__ + "static/media/VPM_desktop_5.8030490a.jpg";